import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type ConstructorVersions as SchemaConstructorVersions } from '../schemas/ConstructorVersions';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Constructor
 */
export const GetConstructorVersionsContentType = '' as const;
export type GetConstructorVersionsRequest = void;
export type GetConstructorVersionsResponses = LinkCommonErrorResponses & {
    /**
     * @description List of constructor versions
     */
    '200': {
        'application/json': SchemaConstructorVersions;
    };
};
export type GetConstructorVersionsResponseSuccess = GetConstructorVersionsResponses['200']['application/json'];
export type GetConstructorVersionsSearchParams = undefined;
export type GetConstructorVersionsPathParameters = undefined;
export const GetConstructorVersionsUrl = '/constructor/versions' as const;
export const GetConstructorVersionsMethod = 'GET' as const;
export const getGetConstructorVersionsUrl = (_params?: GetConstructorVersionsPathParameters) =>
    GetConstructorVersionsUrl;
